export default __webpack_public_path__ + "images/0x188b158caf5ea252012dbd6030afc030329c4961.png";